import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    // 1. Force the element to stay completely visible inside the Shopify Editor sandbox
    if (window.Shopify && window.Shopify.designMode) {
      this.removeAttribute('hidden');
      this.style.setProperty('display', 'block', 'important');
      this.style.setProperty('visibility', 'visible', 'important');
      this.style.setProperty('opacity', '1', 'important');
      
      // Look for hidden parent containers and force them open
      const sectionBg = this.querySelector('.section-background');
      if (sectionBg) sectionBg.style.display = 'block';
      
      const grid = this.querySelector('.blog-posts-container');
      if (grid) {
        grid.style.setProperty('display', 'grid', 'important');
        grid.style.setProperty('visibility', 'visible', 'important');
      }
      return; // Stop the parent framework script from running and hiding elements
    }

    // 2. Otherwise, run the normal pagination logic on the live storefront
    if (super.connectedCallback) {
      super.connectedCallback();
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
